module.exports = __webpack_public_path__ + "img/215.494a9de3.png";